import { inject } from '@angular/core';
import {
  CanMatchFn,
  Route,
  Router,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { authRoutesNames } from 'src/core/routes/auth/auth.routes.names';
import { coreRoutesNames } from 'src/core/routes/core.routes.names';
import { AuthStore } from 'src/core/stores';

export const authGuard: CanMatchFn = (
  _route: Route,
  urlSegments: UrlSegment[],
): boolean | UrlTree => {
  const router = inject(Router);
  const authStore = inject(AuthStore);

  if (authStore.isAuthenticated()) {
    return true;
  }

  const redirectUrl = urlSegments.map((segment) => segment.path).join('/');
  return router.createUrlTree([coreRoutesNames.AUTH, authRoutesNames.LOGIN], {
    queryParams: { redirect: `/${redirectUrl}` },
    queryParamsHandling: 'merge',
  });
};
